__turbopack_context__.v({
  "product-cell": "ReportItemRow-module-scss-module__CfW0gG__product-cell",
});
